module.exports = __webpack_public_path__ + "img/spain.ba252901.svg";